import { createSelector } from '@ngrx/store';
import { TagCreationState } from '@ps/feature-tags';

import { tagsFeature } from './tags.feature';

export const selectTags = tagsFeature.selectTags;
export const selectLoadTagsError = tagsFeature.selectLoadTagsError;
export const selectCreatingTag = tagsFeature.selectCreatingTag;
export const selectCreateTagError = tagsFeature.selectCreateTagError;
export const selectLastCreatedTag = tagsFeature.selectLastCreatedTag;

export const selectTagCreationState = createSelector(
  selectTags,
  selectCreatingTag,
  selectCreateTagError,
  selectLastCreatedTag,
  (tags, creatingTag, createTagError, lastCreatedTag): TagCreationState => ({
    tags,
    creatingTag,
    createTagError,
    lastCreatedTag,
  }),
);
